import React from 'react';

const Hero = () => {
  return (
    <section 
      className="relative bg-cover bg-center min-h-screen text-white flex items-center justify-center"
      style={{ backgroundImage: "url('https://www.kollywoodzone.com/boxoffice/wp-content/uploads/2022/07/South-Indian-Actress-Meenakshi-Hot-Photos-03.jpg')" }}
    >
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="relative container mx-auto px-4 text-center z-10 fade-in">
        <h1 className="text-4xl md:text-7xl font-extrabold mb-4 leading-tight tracking-tight text-shadow-lg">Noida's Premier Escort Service</h1>
        <p className="text-lg md:text-2xl mb-12 max-w-3xl mx-auto text-shadow">
          Indulge in an unforgettable experience with our elite escorts in Noida. We offer discreet and professional companionship for gentlemen of taste.
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-4">
          <a 
            href="#contact"
            className="bg-primary text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-opacity-80 transition duration-300 ease-in-out transform hover:scale-105"
          >
            Book a Date
          </a>
          <a 
            href="#gallery"
            className="border-2 border-white text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-white hover:text-primary transition duration-300 ease-in-out transform hover:scale-105"
          >
            View Gallery
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
